import { Directive, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

export interface LoginUnlockResultParams {
  success: boolean;
  i18nKey: string;
}

@Directive()
export abstract class LoginUnlockResultBaseComponent {
  protected readonly route = inject(ActivatedRoute);

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public readonly params: Signal<LoginUnlockResultParams> = toSignal(
    this.route.queryParamMap.pipe(
      map((queryParams) => ({
        success: queryParams.get('success') === 'true',
        i18nKey: queryParams.get('i18nKey') ?? '',
      })),
    ),
    { initialValue: { success: false, i18nKey: '' } },
  );
}
